import { useTranslation } from 'react-i18next';
import KoobLoaderFullscreen from '@koob/ui/src/components/KoobLoaderFullscreen';
import { ReceiptTypeEnum } from './ReceiptTypeEnum';

export default function ReceiptLoading({ type = ReceiptTypeEnum.TRIP }) {
  const { t } = useTranslation('trips');

  const isBooking = type === ReceiptTypeEnum.BOOKING;
  const title = isBooking
    ? t('receipt.loading.titleBooking')
    : t('receipt.loading.titleTrip');
  const description = isBooking
    ? t('receipt.loading.descriptionBooking')
    : t('receipt.loading.descriptionTrip');

  return <KoobLoaderFullscreen title={title} description={description} />;
}
